// extracted by mini-css-extract-plugin
export default {"VerticalDivider":"📚19-10-2K__PF"};